export default __webpack_public_path__ + "static/media/universal-reverse.145251b6.png";